import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../components/tables/tableContext/TableContext";
import { RecallEntriesListInterface } from "../../../../redux/interfaces/recall.interface";
import { getDateAndTime } from "../../../../utils/dateAndTime";

export const recallEntriesTableHeader: TableHeaderCategoryConfig[] = [
  { value: "documentNumber", label: "Numar document", minW: 250 },
  { value: "createdAt", label: "Data crearii", minW: 170 },
  { value: "pharmacyCount", label: "Farmacii", minW: 100 },
  { value: "generatedNoticeCount", label: "Coduri", minW: 150 },
  { value: "generatedDocumentCount", label: "PDF-uri", minW: 140 },
  { value: "generatedAwbCount", label: "AWB-uri", minW: 140 },
  { value: "returnedDocumentCount", label: "Documente primite", minW: 150 },
];

export const getRecallEntriesTableData = (
  data: RecallEntriesListInterface[],
): TableData[] =>
  data.map((item) => ({
    id: item.idCampaign,
    crudData: item,
    data: [
      { title: item.documentNumber, titleClassName: "break-words" },
      { title: getDateAndTime(item.createdAt, "-") },
      { title: String(item.pharmacyCount) },
      { title: String(item.generatedNoticeCount) },
      { title: String(item.generatedDocumentCount) },
      { title: String(item.generatedAwbCount) },
      { title: String(item.returnedDocumentCount) },
    ],
  }));
